import { GraphQLClient } from 'graphql-request';
import { getSdkWithHooks } from '../generated/graphql';
import { CaApiSdk } from '../types';

export class CaApiSdkManager {
  public static createSdk(token: string | null, apiUrl: string | null): CaApiSdk {
    const client = new GraphQLClient(apiUrl ?? '');

    client.setHeader('Content-Type', 'application/json');
    if (token) {
      client.setHeader('Authorization', `Bearer ${token}`);
    }

    return getSdkWithHooks(client);
  }
}
